<template>
  <base-form-detail
    :controller="controller"
    :readonly="readonly"
    :source="source"
    @close="$emit('close')"
    @save="$emit('save')"
  >
    <entity-card-activities-overview
      :readonly="readonly"
      :source="source"
      :visible="ShowOverview"
      @create="EntityCardMixin_PickersCreate(Pickers.activity)"
      @update="EntityCardMixin_PickersUpdate(Pickers.activity, $event)"
    />
    <dialog-detail
      v-if="entityCardMixin.dialogDetail.show"
      v-model="entityCardMixin.dialogDetail.show"
      :content="entityCardMixin.dialogDetail"
      :parameters="Parameters()"
      @close="EntityCardMixin_PickersClose()"
      @save="DialogDetailSave()"
    />
  </base-form-detail>
</template>

<script>
import BaseFormDetail from '@/components/shared/base/base-form-detail'
import DialogDetail from '@/components/shared/dialogs/dialog-detail'
import EntityCardActivitiesOverview from '@/components/shared/entitycards/entity-card-activities-overview'
import BaseFormDetailMixin from '@/mixins/base-form-detail-mixin'
import EntityCardMixin from '@/mixins/entity-card-mixin'

export default {
  name: 'CarePartnersActivities',
  components: {
    BaseFormDetail,
    DialogDetail,
    EntityCardActivitiesOverview
  },
  mixins: [
    BaseFormDetailMixin,
    EntityCardMixin
  ],
  data () {
    return {
      controller: 'Activity',
      lists: {
        activities: []
      }
    }
  },
  computed: {
    Pickers () {
      return {
        activity: this.EntityCardMixin_Pickers(false, 'Activity', 'activity', 'activities', 'activities-detail', this.PickersReadonly.activity, null, null, null, true)
      }
    },
    PickersReadonly () {
      return {
        activity: this.readonly || !(this.ContentMixin_ElementHasPocoStatus('new') && this.AuthenticationMixin_UserIsAdministrator())
      }
    },
    ShowOverview () {
      return this.visible && !this.entityCardMixin.dialogDetail.show
    }
  },
  async mounted () {
    await this.Initialize()
  },
  methods: {
    async DialogDetailSave () {
      this.EntityCardMixin_PickersSave(this.Pickers[this.entityCardMixin.dialogDetail.type])
    },
    async GetPickerLists () {
      await this.GetPickerPickSources()
      await this.EntityCardMixin_PickersInitialize(this.Pickers)
      await this.EntitiCardMixin_PickersInitializeValue(this.Pickers, this.parameters)
    },
    async GetPickerPickSources () {
      this.lists.activities = await this.ContentMixin_Service_BC_PickSource('Activity')
    },
    async Initialize () {
      await this.BaseFormDetailMixin_Initialize(this.controller)
      await this.GetPickerLists()
      this.SetParameters()
    },
    Parameters () {
      const key = 'idCarePartner'
      return [
        {
          key: key,
          value: this.ContentMixin_Element[key]
        }
      ]
    },
    SetParameters () {
      this.ContentMixin_Store_DetailSourceParameters = this.Parameters()
    }
  }
}
</script>
